import { useEffect, useMemo, useSyncExternalStore } from "react";
import { postPublishQueue } from "../lib/postPublishQueue";
import { auth } from "../lib/firebase";
import { jobsForPostPublishAuthor } from "../lib/postPublishCore";

const enqueue = postPublishQueue.enqueue.bind(postPublishQueue);
const retry = postPublishQueue.retry.bind(postPublishQueue);
const cancel = postPublishQueue.cancel.bind(postPublishQueue);
const remove = postPublishQueue.remove.bind(postPublishQueue);
const reconcileRemote = postPublishQueue.reconcileRemote.bind(postPublishQueue);

export function usePostPublishQueue() {
  const jobs = useSyncExternalStore(
    postPublishQueue.subscribe,
    postPublishQueue.getSnapshot,
    postPublishQueue.getSnapshot
  );
  useEffect(() => {
    postPublishQueue.resume();
  }, []);
  return useMemo(() => ({
    jobs: jobsForPostPublishAuthor(jobs, auth.currentUser?.uid),
    enqueue,
    retry,
    cancel,
    remove,
    reconcileRemote,
  }), [jobs]);
}
